import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
    formatDeadlineDate,
    commitmentOptionsConverter,
} from "@qgiv/p2p-registration";
import { ChipContent } from "@qgiv/core-react";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllRegistration } from "../../../redux/slices/registrationSlice";

const ConnectedCommitmentDetailsChipContent = ({
    categoryId,
    location,
    details,
}) => {
    const categories = useSelector(selectAllCategories);
    const category = categories.find(
        (_category) => _category.id === categoryId,
    );
    const isCms = useSelector(selectIsCms);

    // If user selects a category, then clicks that category again we no longer have
    // access to this category and it will throw a type error. Must first check for its existence
    // before destructuring.
    let commitmentDeadline;
    let commitmentAmount;
    if (category) {
        ({ commitmentDeadline, commitmentAmount } = category);
    }

    const currency = useSelector((state) =>
        selectSpecificFormSetting(state, "currency"),
    );
    const { timezone = "" } = useSelector(selectAllP2pSettings);
    const registration = useSelector(selectAllRegistration);

    const isAdditionalParticipant =
        registration &&
        registration.currentRegistration &&
        registration.currentRegistration > 0;

    const formattedDeadlineDate =
        commitmentDeadline &&
        timezone &&
        formatDeadlineDate(commitmentDeadline, timezone);

    const formattedOptions = commitmentOptionsConverter(
        details,
        commitmentAmount,
        formattedDeadlineDate,
        currency,
        isCms,
    );

    let label;
    if (location === "category") {
        label = formattedOptions;
    }
    // due to legal concerns we want to display the fundraising goal commitment disclaimer in bold
    if (location === "fundraisingGoal") {
        // Primary Registrant / Managed Participant messaging
        if (!isAdditionalParticipant) {
            label = `<strong>${formattedOptions.commitmentDetails}</strong>`;
        } else {
            // Additional Participant messaging
            label = `<strong>${formattedOptions.commitmentDetailsAdditionalParticipants}</strong>`;
        }
    }

    const chipContentProps = {
        label,
        glyph: "bullseye-arrow-regular",
    };

    return <ChipContent {...chipContentProps} />;
};

ConnectedCommitmentDetailsChipContent.propTypes = {
    details: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
        .isRequired,
    location: PropTypes.string.isRequired,
    categoryId: PropTypes.number.isRequired,
};

export default ConnectedCommitmentDetailsChipContent;
